import { render, staticRenderFns } from "./MaterialSnackbar.vue?vue&type=template&id=1f19473a&"
import script from "./MaterialSnackbar.vue?vue&type=script&lang=js&"
export * from "./MaterialSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./MaterialSnackbar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VSnackbar})
